import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Paper from '@mui/material/Paper';
import { Fragment } from 'react';
import { useAppSelector } from '../../redux/store';
import { PRIVATE_MESSAGES_CONVERSATION_DIVIDER_COLOR, PRIVATE_MESSAGES_PANEL_LIST_BACKGROUND_COLOR } from '../../styles/colors';
import { range } from '../../utils/utils';
import { PanelHeader } from '../panelHeader';
import { PanelItemDivider } from '../panelItemDivider';
import { ConversationSelectPanelItem } from './conversationSelectPanelItem';
const CONTAINER_CSS = css `
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${PRIVATE_MESSAGES_PANEL_LIST_BACKGROUND_COLOR} !important;
  display: flex;
  flex-direction: column;
`;
const EMPTY_LIST_CSS = css `
  color: black;
  padding: 20px;
`;
export const ConversationsContainer = () => {
    const hasFetchedRecentConversations = useAppSelector((state) => state.directMessages.hasFetchedRecentConversations);
    const numConversations = useAppSelector((state) => state.directMessages.conversations.length);
    if (!hasFetchedRecentConversations) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(PanelHeader, { title: 'Recent Conversations', withPadding: true }), _jsx(Paper, { component: 'section', "aria-label": 'recent conversations', css: CONTAINER_CSS, children: numConversations > 0 ? (range(numConversations).map((i) => (_jsxs(Fragment, { children: [_jsx(ConversationSelectPanelItem, { conversationIndex: i }), _jsx(PanelItemDivider, { color: PRIVATE_MESSAGES_CONVERSATION_DIVIDER_COLOR })] }, i)))) : (_jsx("div", { css: EMPTY_LIST_CSS, children: "No recent conversations." })) })] }));
};
